/** Mulberry32 — tiny seeded PRNG so playback can be deterministic. */
export function createRandom(seed?: number): () => number {
  if (seed === undefined) {
    return Math.random;
  }
  let a = seed >>> 0;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}
